import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IconButton, Switch, Tooltip, FormControlLabel } from "@mui/material";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { toggleAndPersistTheme } from "../store/slices/themeSlice";

export const ThemeToggleButton = ({ sx }) => {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.theme.mode);
  const isDark = mode === "dark";

  return (
    <Tooltip title={isDark ? "Light mode" : "Dark mode"}>
      <IconButton
        onClick={() => dispatch(toggleAndPersistTheme())}
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
        sx={sx}
      >
        {isDark ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
      </IconButton>
    </Tooltip>
  );
};

export const ThemeToggleSwitch = () => {
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.theme.mode);

  return (
    <FormControlLabel
      control={
        <Switch
          checked={mode === "dark"}
          onChange={() => dispatch(toggleAndPersistTheme())}
        />
      }
      label="Dark mode"
    />
  );
};

export default ThemeToggleButton;
